import { render } from "./DetailMeter.vue?vue&type=template&id=2ec80adc&scoped=true"
import script from "./DetailMeter.vue?vue&type=script&lang=js"
export * from "./DetailMeter.vue?vue&type=script&lang=js"

import "./DetailMeter.vue?vue&type=style&index=0&id=2ec80adc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec80adc"]])

export default __exports__